import { render } from "./LoginAdmin.vue?vue&type=template&id=0a7d0c2d&scoped=true"
import script from "./LoginAdmin.vue?vue&type=script&lang=js"
export * from "./LoginAdmin.vue?vue&type=script&lang=js"

import "./LoginAdmin.vue?vue&type=style&index=0&id=0a7d0c2d&scoped=true&lang=css"

import exportComponent from "D:\\Development\\Illyrian\\witsrhi-journeytool-myprep\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7d0c2d"]])

export default __exports__